module.exports = __webpack_public_path__ + "img/win_icon.e007a992.svg";